var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",class:_vm.alignmentClasses},[_c('UniversalLink',{attrs:{"link":_vm.data.linkUrl,"openNewWindow":_vm.data.linkTarget === 'NEW_WINDOW'}},[_c('Picture',_vm._g(_vm._b({},'Picture',_vm.pictureBindings,false),_vm.pictureEvents))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }